export const CREATE_ACCOUNT = '[ Admin ] Create account'
export const FETCH_ACCOUNTS = '[ Admin ] Fetch Accounts'
export const FETCH_HOME = '[ Admin ] Fetch Home'
export const IMPERSONATE = '[ Admin ] Impersonate user'
export const RESET_PASSWORD = '[ Admin ] Reset account password'
export const UPDATE_HOME = '[ Admin ] Update Home'
